<div class="item-container d-flex flex-row align-items-center justify-content-between">
  <div class="left-container d-flex flex-row align-items-center">
    <div class="player-img-container">
      <ng-container *ngIf="fantasyHistoryItem.PlayerImage; else noImage">
        <img src="{{ fantasyHistoryItem.PlayerImage | contentImage: '6' }}" alt="" class="h-100 w-100" />
      </ng-container>
      <ng-template #noImage>
        <img [src]="'placeholders/placeholderplayer.svg' | contentAssetImage" alt="" class="h-100 w-100" />
      </ng-template>
    </div>
    <div class="details-container d-flex h-100 flex-column justify-content-between">
      <p class="font-size-14 fw-bold mb-0 text-white">
        {{ fantasyHistoryItem.PlayerName }}
      </p>
      <p class="font-size-12 mb-0 text-white">
        <span class="text-lowercase">{{ 'fantasy.game.vs' | translate }}</span> {{ getOpponentTeamName() }}
      </p>
      <p class="font-size-12 mb-0 text-white">{{ gameDate | date: 'EEE MMM dd' }}</p>
    </div>
  </div>

  <div class="right-container d-flex align-items-center justify-content-end">
    <div class="text-end font-size-16 fw-bold text-white" *ngIf="!isPending; else pointsPending">
      {{ fantasyHistoryItem.PlayerGamePoints / 100 }}
    </div>
    <ng-template #pointsPending>
      <span class="font-size-16 fw-bold text-white">{{ 'fantasy.results.points.pending' | translate }}</span>
    </ng-template>
  </div>
</div>
